export const tokenNodeTypeObj = {
  eth: 'ERC-20',
  bsc: 'BEP-20',
  trx: 'TRC-20',
};


export const notIncludedNodeType = ['optimism', 'matic', 'arbitrum', 'avax', 'solana', 'ftm', 'moonbeam']

export const NON_EVM_NODE_TYPES = ['btc', 'trx', 'dot', 'ksm', 'solana', 'ton']

export const isEvmNodeType = (nodeType) => !!nodeType && !NON_EVM_NODE_TYPES.includes(nodeType)

export const getAssetDisplaySuffix = (currencyType, nodeType, currency) => {
  return tokenTypeEnd(currencyType, nodeType, currency)
    || (currencyType === 'token' ? tokenNodeTypeObj[nodeType] || '' : '');
};

export const tokenTypeEnd = (currencyType, nodeType, currency ) => {
  const currencyUSDTorUSDC = currency === 'USDT' || currency === 'USDC' || currency === 'TUSD';

  if (currencyType === 'token' && nodeType === 'arbitrum' && currency === 'WBTC') {
    return "ARB"
  }
  if (currencyType === 'token' && nodeType === 'arbitrum' && currency === 'LINK') {
    return "ARB"
  }
  if (currencyType === 'token' && nodeType === 'arbitrum' && currency === 'Link') {
    return "ARB"
  }
  if (currencyType === 'token' && nodeType === 'matic' && currency === 'LINK') {
    return "MATIC"
  }
  if (currencyType === 'token' && nodeType === 'ton' && currency === 'DOGS') {
    return "GRAM"
  }
  if (currencyType === 'token' && nodeType === 'ton' && currency === 'CATI') {
    return "GRAM"
  }
  if (currencyType === 'token' && nodeType === 'ton' && currency === 'HMSTR') {
    return "GRAM"
  }
  if (currencyType === 'token' && nodeType === 'ton' && currency === 'NOT') {
    return "GRAM"
  }
  if (currencyType === 'token' && nodeType === 'matic' && currency === 'WBTC') {
    return "MATIC"
  }
  if (currencyType === 'token' && nodeType === 'solana' && currency === 'BONK') {
    return "SOL"
  }
  if (currencyType === 'token' && nodeType === 'solana' && currency === 'WIF') {
    return "SOL"
  }
  if (currencyType === 'token' && nodeType === 'solana' && currency === 'XRP') {
    return "SOL"
  }
  if (currencyType === 'token' && nodeType === 'solana' && currency === 'LINK') {
    return "SOL"
  }
  if (currencyType === 'token' && nodeType === 'solana' && currency === 'WBTC') {
    return "SOL"
  }
  if (currencyType === 'token' && nodeType === 'optimism' && currency !== 'OP') {
    return "OP"
  }
  if (currencyType === 'currency' && nodeType === 'base') {
    return "BASE"
  }
  if (currencyType === 'token' && nodeType === 'base') {
    return "BASE"
  }
  if (currency === 'ETH' && currencyType === 'currency' && nodeType === 'optimism') {
    return "OP"
  }
  if (currencyType === 'currency' && nodeType === 'arbitrum' && currency !== 'arbitrum') {
    return 'ARB'
  }
  if ((currencyUSDTorUSDC || currency === 'ETH') && currencyType === 'token' && nodeType === 'arbitrum') {
    return "ARB"
  }
  if (currencyUSDTorUSDC && currencyType === 'token' && nodeType === 'matic') {
    return 'Polygon'
  }
  if (currency === 'USDT' && currencyType === 'token' && nodeType === 'avax') {
    return 'AVAX'
  }
  if (currency === 'USDC' && currencyType === 'token' && nodeType === 'solana') {
    return "SOL"
  }
  if (currency === 'USDT' && currencyType === 'token' && nodeType === 'ftm') {
    return "FTM"
  }
  if (currencyUSDTorUSDC && currencyType === 'token' && nodeType === 'moonbeam') {
    return "Moonbeam"
  }
  if (currency === 'ETH' && currencyType === 'currency' && nodeType === 'blast') {
    return "Blast"
  }
  if (currencyUSDTorUSDC && currencyType === 'token' && nodeType === 'ton') {
    return "GRAM"
  }
}